import React from 'react';

import { Grid, Section } from '@gogame/components';
import { FormField } from '@gogame/form';

import DateRangeWithConstants from 'scenes/CustomAudiences/Audiences/components/AudienceForm/DateRangeWithConstants';
import { ACTIVITY } from 'scenes/CustomAudiences/Audiences/components/AudienceForm/constants';
import { useCanEditAll } from 'scenes/CustomAudiences/EditGranularityContext';

import {
  REG_PERIOD,
  ACTIVITY_PERIOD,
  USER_LEVEL,
  DAYS_OFFLINE,
  SENIORITY_DAYS,
  INACTIVE_SINCE_DATE,
  RE_COUNTER,
} from './constants';

const FieldSet = () => {
  const canEditAll = useCanEditAll();
  return (
    <Section title={'Activity'}>
      <Grid container spacing={3}>
        <Grid item xs={4}>
          <DateRangeWithConstants
            padding={0}
            constants={true}
            name={`${ACTIVITY}.${REG_PERIOD}`}
            label={'Registration period'}
            required={true}
            disabled={!canEditAll}
          />
        </Grid>
        <Grid item xs={4}>
          <DateRangeWithConstants
            required={true}
            padding={0}
            name={`${ACTIVITY}.${ACTIVITY_PERIOD}`}
            label={'Last activity period'}
            disabled={!canEditAll}
          />
        </Grid>
        <Grid item xs={4}>
          <FormField.DatePicker
            name={`${ACTIVITY}.${INACTIVE_SINCE_DATE}`}
            label={'Inactive since'}
            padding={0}
            disabled={!canEditAll}
          />
        </Grid>
        <Grid item xs={2}>
          <FormField.TextField
            range={true}
            name={`${ACTIVITY}.${USER_LEVEL}`}
            label={'Users level'}
            padding={0}
            disabled={!canEditAll}
          />
        </Grid>
        <Grid item xs={2}>
          <FormField.TextField
            range={true}
            name={`${ACTIVITY}.${DAYS_OFFLINE}`}
            label={'Days offline'}
            padding={0}
            disabled={!canEditAll}
          />
        </Grid>
        <Grid item xs={2}>
          <FormField.TextField
            range={true}
            name={`${ACTIVITY}.${SENIORITY_DAYS}`}
            label={'Seniority days'}
            padding={0}
            disabled={!canEditAll}
          />
        </Grid>
        <Grid item xs={2}>
          <FormField.TextField
            range={true}
            name={`${ACTIVITY}.${RE_COUNTER}`}
            label={'RE Counter'}
            padding={0}
            disabled={!canEditAll}
          />
        </Grid>
      </Grid>
    </Section>
  );
};

export default FieldSet;
